<template>
  <div ref="scrollableBox" :key="dataScroll" class="scrollableBoxContainer">
    <div v-if="$store.isSP" ref="scrollBar" :class="{ active, disableAnimation, animation: !disableAnimation }" class="scrollableBox sp">
      <div class="scrollableBox-inner"><slot /></div>
    </div>
    <div
      v-else
      ref="box"
      :class="{ enableScroll: enableScroll }"
      class="scrollableBox pc"
      @mousedown="mouseStart"
      @touchstart="touchStart"
      @mousemove="mouseMove"
      @touchmove="touchMove"
      @mouseup="end"
      @touchend="end"
      @mouseleave="end"
    >
      <div class="scrollableBox-inner"><slot /></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disableAnimation: { type: Boolean, default: false, required: false },
    enableScroll: { type: Boolean, default: false, required: false }
  },
  setup() {
    const scrollableBox = ref(null)
    return {
      scrollableBox
    }
  },
  data() {
    return {
      baseScrollLeft: null,
      startX: null,
      moveX: null,
      active: false,
      dataScroll: 0
    }
  },
  computed: {
    diffX() {
      return this.moveX - this.startX
    },
    box() {
      return this.$refs.box
    }
  },
  watch: {
    '$route.query'() {
      if (this.$refs.scrollableBox) {
        this.dataScroll += 1
      }
    }
  },
  mounted() {
    this.activeScrollableBox()
    window.addEventListener('scroll', this.activeScrollableBox, { passive: true })
  },
  unmounted() {
    window.removeEventListener('scroll', this.activeScrollableBox)
  },
  methods: {
    mouseStart(e) {
      e.preventDefault()
      this.baseScrollLeft = this.box.scrollLeft
      this.startX = e.pageX
    },
    touchStart(e) {
      e.preventDefault()
      this.baseScrollLeft = this.box.scrollLeft
      this.startX = e.changedTouches[0].screenX
    },
    mouseMove(e) {
      if (this.startX === null) return
      this.moveX = e.pageX
      this.box.scrollLeft = this.baseScrollLeft - this.diffX
    },
    touchMove(e) {
      if (this.startX === null) return
      this.moveX = e.changedTouches[0].screenX
      this.box.scrollLeft = this.baseScrollLeft - this.diffX
    },
    end(e) {
      this.baseScrollLeft = null
      this.startX = null
      this.moveX = null
    },
    move(diff) {
      const baseScrollLeft = this.box.scrollLeft
      this.box.scrollLeft = baseScrollLeft - diff
    },
    activeScrollableBox() {
      if (!this.scrollableBox) return
      const itemBottom = this.scrollableBox.getBoundingClientRect().bottom
      const itemTop = this.scrollableBox.getBoundingClientRect().top
      if (!this.disableAnimation && itemTop > 0 && itemBottom < window.innerHeight) {
        this.active = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scrollableBox {
  overflow-x: auto;
  &.pc {
    overflow-x: hidden;
    user-select: none;
  }
  &.enableScroll {
    overflow-x: auto;
    @include pc {
      .scrollableBox-inner {
        margin: 0 auto;
      }
    }
  }
  &.sp {
    overflow-x: auto;
  }
  &-inner {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: none;
    width: max-content;
  }
  &.animation {
    opacity: 0.5;
    transform: translate(20px, 0);
    transition:
      transform 0.6s ease-in-out,
      opacity 0.6s ease;
    &.active {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
  &.disableAnimation {
    opacity: 1;
  }
}
</style>
